module.exports = __webpack_public_path__ + "static/img/2.c4d4d1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.png
// module id = chPc
// module chunks = 1